import { Text } from '../index';

export const Container = ({ children }: React.PropsWithChildren) => (
  <table className='w-100'>
    <tbody>{children}</tbody>
  </table>
);

export const Row = ({ children }: React.PropsWithChildren) => (
  <tr>{children}</tr>
);
export const Label = ({ children }: React.PropsWithChildren) => (
  <td className='d-flex'>
    <Text weight='semi-bold' color='secondary-gray'>
      {children}
    </Text>
  </td>
);
export const Value = ({
  children,
  id,
  ...rest
}: React.PropsWithChildren<{ id: string }>) => (
  <td style={{ width: '50%' }}>
    <Text weight='semi-bold' color='secondary' {...rest} id={id} data-cy={id}>
      {children}
    </Text>
  </td>
);
